var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { configureAmplify, Trace, Log } from '@amzn/showtime';
import TENANT_ID from '../TenantId';
const logger = Log(TENANT_ID);
export default function bootstrapMetrics({ bundleVersion }) {
    return __awaiter(this, void 0, void 0, function* () {
        const trace = Trace('BootstrapMetrics', TENANT_ID);
        try {
            yield configureAmplify(bundleVersion);
            trace.log();
        }
        catch (err) {
            logger.error('MetricBootstrappingError', { error: err });
        }
    });
}
//# sourceMappingURL=MetricBootstrapping.js.map